import type { FluentIconsProps } from "@fluentui/react-icons";

// Fluent's "resizable" icons (the unsized Regular/Filled exports) take their
// pixel size via a `fontSize` prop, not `size` — this wraps one so call sites
// across the app can keep passing a plain pixel `size`, the same shape
// lucide-react used.
//
// Icon param is untyped: admin pins @types/react 18 while the workspace's
// hoisted @types/react is 19, and React 19's ReactNode includes `bigint`,
// which isn't assignable to React 18's ReactNode — no component-typed
// signature (ComponentType, ElementType, a literal FC signature) satisfies
// both simultaneously, confirmed by trying each against `tsc --noEmit`.
// Both are the same plain function component at runtime; this only relaxes
// a type-only cross-version mismatch between the two @types/react copies.
export function fluentIcon(Icon: any) {
  return function SizedIcon({ size = 16, ...rest }: FluentIconsProps & { size?: number }) {
    return <Icon fontSize={size} {...rest} />;
  };
}
